import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

async function getInspectionList(search, pageable) {
    console.log(">> 점검관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/maintenance/inspection?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getInspectionHeaderList(search, pageable) {
    console.log(">> 점검계획관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post(`/maintenance/inspection_header?`+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeInspections(ids) {
    try {
        return await needAuth.put('/maintenance/inspection/delete', ids);
    }catch (error){
        return error
    }
}

async function removeInspectionHeaders(ids) {
    try {
        return await needAuth.put('/maintenance/inspection_header/delete', ids);
    }catch (error){
        return error
    }
}


async function getInspection(id) {
    try {
        return await needAuth.get('/maintenance/inspection/'+id);
    }catch (error){
        return error
    }
}

async function getInspectionHeader(id) {
    try {
        return await needAuth.get('/maintenance/inspection_header/'+id);
    }catch (error){
        return error
    }
}

async function saveInspection(inspection, assets, handler, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    const assetData = assets?.map(item => ({id : item.id}));
    inspection.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    inspection.handlerIds = handlerIds;

    formData.append(
        "inspectionRequestDto",
        new Blob([JSON.stringify(inspection)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/maintenance/inspection/create`, inspection);
    }catch (error){
        return error
    }
}

async function updateInspection(inspection, assets, handler, files) {
    const assetData = assets?.map(item => ({id : item.id}));
    inspection.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    inspection.handlerIds = handlerIds;

    try {
        return await needAuth.post(`/maintenance/inspection/update`, inspection);
    }catch (error){
        return error
    }
}

async function updateInspectionHeader(inspection, assets, handler, files) {
    const assetData = assets?.map(item => ({id : item.id}));
    inspection.assetIds = assetData;

    const handlerIds = handler?.map(item => (item.id));
    inspection.handlerIds = handlerIds;
    try {
        return await needAuth.post(`/maintenance/inspection_header/update`, inspection);
    }catch (error){
        return error
    }
}

const updateInspectionForInProgress = async (data, files) => {
    const formData = new FormData();
    files.forEach((file, index) => {formData.append(`files`, file.object);});
    formData.append("requestDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

    try {
        return await needAuth.put(
            `/maintenance/inspection/inProgress`, formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
        )
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const updateInspectionForVerification = async (data) => {
    try {
        return await needAuth.put(`/maintenance/inspection/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function removeInspectionReport(id) {
    try {
        return await needAuth.put('/maintenance/inspection/report/delete', id);
    }catch (error){
        return error
    }
}

async function getInspectionReport(id) {
    try {
        return await needAuth.get('/maintenance/inspection/report/'+id);
    }catch (error){
        return error
    }
}

async function saveInspectionReport(inspectionReport, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "inspectionReportRequestDto",
        new Blob([JSON.stringify(inspectionReport)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/maintenance/inspection/report/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error
    }
}

async function updateInspectionReport(inspection) {
    try {
        return await needAuth.post(`/maintenance/inspection/report/update`, inspection);
    }catch (error){
        return error
    }
}

export {
    getInspectionList,
    removeInspections,
    saveInspection,
    getInspection,
    getInspectionHeaderList,
    getInspectionHeader,
    removeInspectionHeaders,
    updateInspection,
    updateInspectionHeader,
    updateInspectionForInProgress,
    updateInspectionForVerification,
    removeInspectionReport,
    updateInspectionReport,
    getInspectionReport,
    saveInspectionReport
}